import { css, FlattenSimpleInterpolation } from 'styled-components';
import { HeadingType } from '../components/atoms/Heading/Heading.data';
import { ParagraphType } from '../components/atoms/Paragraph/Paragraph.data';
import { FontWeight } from './variables';

type TypeStyles = ParagraphType | HeadingType;

export const typeStyle: Record<TypeStyles, FlattenSimpleInterpolation> = {
  [HeadingType.H1]: css`
    font-size: 24px;
    line-height: 1.25;
    font-weight: ${FontWeight.Bold};
  `,
  [ParagraphType.Intro]: css`
    font-size: 18px;
    line-height: 1.333;
    font-weight: ${FontWeight.Normal};
  `,
  [ParagraphType.CallToAction]: css`
    font-size: 16px;
    line-height: 1.125;
    font-weight: ${FontWeight.Bold};
  `,
  [ParagraphType.Large]: css`
    font-size: 16px;
    line-height: 1.125;
    font-weight: ${FontWeight.Normal};
  `,
  [ParagraphType.Normal]: css`
    font-size: 14px;
    line-height: 1.142;
    font-weight: ${FontWeight.Normal};
  `,
  [ParagraphType.Small]: css`
    font-size: 12px;
    line-height: 1.1666;
    font-weight: ${FontWeight.Normal};
  `,
} as const;

export type TypeStyleType = typeof typeStyle;
